// extracted by mini-css-extract-plugin
export var auto = "_3j-1";
export var spinner = "_3j-0";